import { render, staticRenderFns } from "./Dynamic-Responses.vue?vue&type=template&id=1d9a9d58&scoped=true"
import script from "./Dynamic-Responses.vue?vue&type=script&lang=js"
export * from "./Dynamic-Responses.vue?vue&type=script&lang=js"
import style0 from "./Dynamic-Responses.vue?vue&type=style&index=0&id=1d9a9d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a9d58",
  null
  
)

export default component.exports